import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { ISettlementDetailsData } from '../../order/order-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import { getFormattedDate } from '../../../utils/utilities';
import { Link } from 'react-router-dom';
import { CellWithCurrency } from '../../../components/table/CellWithCurrency';
import React from 'react';

export enum PayoutDetailsTableAccessorKeys {
	orderDate = 'orderDate',
	externalOrderId = 'externalOrderId',
	type = 'type',
	amount = 'amount',
	adjustment = 'adjustment',
	flexChargeFee = 'flexChargeFee',
	payout = 'payout',
	paymentType = 'paymentType',
}

export const defaultPayoutDetailsColumnSizing: ColumnSizing = {
	[PayoutDetailsTableAccessorKeys.orderDate]: 70,
	[PayoutDetailsTableAccessorKeys.externalOrderId]: 120,
	[PayoutDetailsTableAccessorKeys.type]: 60,
	[PayoutDetailsTableAccessorKeys.amount]: 80,
	// [PayoutDetailsTableAccessorKeys.adjustment]: 80,
	// [PayoutDetailsTableAccessorKeys.flexChargeFee]: 80,
	[PayoutDetailsTableAccessorKeys.paymentType]: 80,
	[PayoutDetailsTableAccessorKeys.payout]: 80,
};

export const defaultPayoutDetailsColumns: MRT_ColumnDef<ISettlementDetailsData>[] =[
	{
		accessorKey: PayoutDetailsTableAccessorKeys.orderDate,
		header: 'Order date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getFormattedDate(renderedCellValue, 'MMM dd, yyyy')}
			</TableCell>
		)
	},
	{
		accessorKey: PayoutDetailsTableAccessorKeys.externalOrderId,
		header: 'External order id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">External order id</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<Link
					to={row?.original?.orderId && `/orders/${row?.original?.orderId}`}
					className="text-black fs-7 ms-3 fc-text-overflow fw-bolder"
				>
					{renderedCellValue ? renderedCellValue : '-'}
				</Link>
			</TableCell>
		)
	},
	{
		accessorKey: PayoutDetailsTableAccessorKeys.type,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PayoutDetailsTableAccessorKeys.paymentType,
		header: 'Payment type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Payment type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PayoutDetailsTableAccessorKeys.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<CellWithCurrency
					value={renderedCellValue}
					currencySymbol={row?.original?.currencySymbol}
					currencyCode={row?.original?.currency}
					isPositive={renderedCellValue >= 0}
				/>
			</TableCell>
		)
	},
	// {
	// 	accessorKey: PayoutDetailsTableAccessorKeys.adjustment,
	// 	header: 'Adjustment',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Adjustment</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			<CellWithCurrency
	// 				value={renderedCellValue}
	// 				currencySymbol='$'
	// 				currencyCode="USD"
	// 				isPositive={renderedCellValue >= 0}
	// 			/>
	// 		</TableCell>
	// 	)
	// },
	// {
	// 	accessorKey: PayoutDetailsTableAccessorKeys.flexChargeFee,
	// 	header: 'FlexCharge Fees',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">FlexCharge Fees</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			<CellWithCurrency
	// 				value={renderedCellValue}
	// 				currencySymbol='$'
	// 				currencyCode="USD"
	// 				isPositive={renderedCellValue === 0}
	// 			/>
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: PayoutDetailsTableAccessorKeys.payout,
		header: 'Payout',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Payout</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<CellWithCurrency
					value={renderedCellValue}
					currencySymbol={row?.original?.currencySymbol}
					currencyCode={row?.original?.currency}
					isPositive={renderedCellValue >= 0 || row?.original?.paymentType.toLowerCase() !== 'debit'}
				/>
			</TableCell>
		)
	},
];
